import { formatSignedPoints } from './formatSignedPoints';

import type { DivergingBarAxis } from '@amelio/ui-library';

/** Fraction of `axisPoints` the two intermediate graduations sit at, between the center and each
 * end of the axis. */
const HALF_AXIS_FACTOR = 0.5;

export interface BuildDeviationAxisOptions {
    /** The report's `deviationAxisPoints`: the axis runs from `-axisPoints` to `+axisPoints`. */
    axisPoints: number;
    language: string;
    centerLabel: string;
}

/**
 * Builds the manager-deviation chart's axis — `[-N, -N/2, N/2, N]`, labelled with
 * `formatSignedPoints` — in `@amelio/ui-library`'s `DivergingBarAxis` shape. No graduation sits at
 * the center: `DivergingBarChart` draws `centerLabel` (e.g. "Cohorte") there itself, so a tick at
 * `0` would print a second label on top of it.
 */
export const buildDeviationAxis = ({
    axisPoints,
    language,
    centerLabel,
}: BuildDeviationAxisOptions): DivergingBarAxis => {
    const tickValues = [
        -axisPoints,
        -axisPoints * HALF_AXIS_FACTOR,
        axisPoints * HALF_AXIS_FACTOR,
        axisPoints,
    ];

    return {
        min: -axisPoints,
        max: axisPoints,
        ticks: tickValues.map((value) => ({
            value,
            label: formatSignedPoints({ value, language }),
        })),
        centerLabel,
    };
};
